import { Singleton } from 'typescript-ioc'
import { APIClientBase } from './APIClientBase'

@Singleton
export class UsersAPIClient extends APIClientBase {
  /**
   * Instanciate api client
   */
  constructor () {
    super('users')
  }
}
